import { WorkflowItem } from '../../../core/submission/models/workflowitem.model';
import { SearchResult } from '../../search/models/search-result.model';

/**
 * Represents a search result object of a WorkflowItem object
 */
export class WorkflowItemSearchResult extends SearchResult<WorkflowItem> {
}
